/**
* DO NOT EDIT THIS FILE.
* See the following change record for more information,
* https://www.drupal.org/node/2815083
* @preserve
**/
import LuminisServiceUtils from "../utils/luminis-service-utils.es6.js";
import VirtualUrgentCareTermsAndConditionsModalParagraph from "../paragraphs/virtual-urgent-care-terms-and-conditions-modal-paragraph.es6.js";
import OverlayService from "../overlay-service.es6.js";
(function () {
  var luminisServiceUtils = new LuminisServiceUtils();
  var overlayService = new OverlayService();
  var paragraph = new VirtualUrgentCareTermsAndConditionsModalParagraph({
    luminisServiceUtils: luminisServiceUtils,
    overlayService: overlayService
  });
  paragraph.onRendered(function () {
    paragraph.initialize();
  });
})(Drupal);